import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const links = [
  { label: 'About', href: 'identity' },
  { label: 'Sound', href: 'sound' },
  { label: 'Journey', href: 'journey' },
  { label: 'World', href: 'sonic' },
  { label: 'Contact', href: 'contact' },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.scrollY - 60;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const handleClick = (id) => {
    setOpen(false);
    setTimeout(() => scrollTo(id), 100);
  };

  return (
    <>
      <nav className={`nav${scrolled ? ' nav--scrolled' : ''}`} data-testid="navbar">
        <a
          href="#hero"
          className="nav-logo"
          onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}
          data-testid="nav-logo"
        >
          Lulo Lonke
        </a>
        <div className="nav-links" data-testid="nav-links-desktop">
          {links.map(({ label, href }) => (
            <a
              key={href}
              href={`#${href}`}
              onClick={(e) => { e.preventDefault(); scrollTo(href); }}
              data-testid={`nav-link-${label.toLowerCase()}`}
            >
              {label}
            </a>
          ))}
        </div>
        <button
          className="nav-mobile-toggle"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
          data-testid="mobile-menu-toggle"
        >
          <Menu size={22} />
        </button>
      </nav>

      <div className={`mobile-menu${open ? ' mobile-menu--open' : ''}`} data-testid="mobile-menu">
        <div className="mobile-menu-backdrop" onClick={() => setOpen(false)} />
        <div className="mobile-menu-drawer">
          <button
            className="mobile-menu-close"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
            data-testid="mobile-menu-close"
          >
            <X size={22} />
          </button>
          <div className="mobile-menu-links">
            {links.map(({ label, href }) => (
              <a
                key={href}
                href={`#${href}`}
                onClick={(e) => { e.preventDefault(); handleClick(href); }}
                data-testid={`mobile-link-${label.toLowerCase()}`}
              >
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
